import React from "react";
import ShopCreate from "../components/Shop/ShopCreate";

const ShopCreatePage = () => {
  return <ShopCreate />;
};

export default ShopCreatePage;
